export default "__VITE_PUBLIC_ASSET__ec540fbe__"